<template>
  <div>
    <!-- :style="{ 'background-image': previewImage ? `url(${previewImage})` : 'url()' }" -->
    <div
      class="imagePreviewWrapper"
      :style="{
        'background-image': imageUrl.length > 0
          ? `url(${imageUrl})`
          : previewImage
          ? `url(${previewImage})`
          : 'url(' +
            require('@/assets/images/settings/img-placeholder.png') +
            ')',
      }"
      @click="selectImage"
    >
    <svg width="30" height="31" viewBox="0 0 30 31" class="img-fluid img-upload-icon" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15.5" r="15" fill="#FCC210"/>
      <g clip-path="url(#clip0)">
      <path d="M21.1665 19.1683C21.1665 19.3893 21.0787 19.6013 20.9224 19.7575C20.7661 19.9138 20.5542 20.0016 20.3332 20.0016H10.3332C10.1122 20.0016 9.9002 19.9138 9.74391 19.7575C9.58763 19.6013 9.49984 19.3893 9.49984 19.1683V14.1683C9.49984 13.9473 9.58763 13.7353 9.74391 13.579C9.9002 13.4228 10.1122 13.335 10.3332 13.335H11.3098C11.9725 13.3346 12.608 13.0711 13.0765 12.6025L13.7682 11.9125C13.924 11.7566 14.1353 11.6688 14.3557 11.6683H16.309C16.53 11.6683 16.7419 11.7562 16.8982 11.9125L17.5882 12.6025C17.8204 12.8347 18.096 13.019 18.3995 13.1446C18.7029 13.2703 19.0281 13.335 19.3565 13.335H20.3332C20.5542 13.335 20.7661 13.4228 20.9224 13.579C21.0787 13.7353 21.1665 13.9473 21.1665 14.1683V19.1683ZM10.3332 12.5016C9.89114 12.5016 9.46722 12.6772 9.15466 12.9898C8.8421 13.3023 8.6665 13.7263 8.6665 14.1683V19.1683C8.6665 19.6103 8.8421 20.0342 9.15466 20.3468C9.46722 20.6594 9.89114 20.835 10.3332 20.835H20.3332C20.7752 20.835 21.1991 20.6594 21.5117 20.3468C21.8242 20.0342 21.9998 19.6103 21.9998 19.1683V14.1683C21.9998 13.7263 21.8242 13.3023 21.5117 12.9898C21.1991 12.6772 20.7752 12.5016 20.3332 12.5016H19.3565C18.9145 12.5015 18.4907 12.3259 18.1782 12.0133L17.4882 11.3233C17.1757 11.0107 16.7518 10.8351 16.3098 10.835H14.3565C13.9145 10.8351 13.4907 11.0107 13.1782 11.3233L12.4882 12.0133C12.1757 12.3259 11.7518 12.5015 11.3098 12.5016H10.3332Z" fill="#383F51"/>
      <path d="M15.333 18.335C14.7805 18.335 14.2506 18.1155 13.8599 17.7248C13.4692 17.3341 13.2497 16.8042 13.2497 16.2516C13.2497 15.6991 13.4692 15.1692 13.8599 14.7785C14.2506 14.3878 14.7805 14.1683 15.333 14.1683C15.8855 14.1683 16.4154 14.3878 16.8061 14.7785C17.1968 15.1692 17.4163 15.6991 17.4163 16.2516C17.4163 16.8042 17.1968 17.3341 16.8061 17.7248C16.4154 18.1155 15.8855 18.335 15.333 18.335ZM15.333 19.1683C16.1066 19.1683 16.8484 18.861 17.3954 18.314C17.9424 17.767 18.2497 17.0252 18.2497 16.2516C18.2497 15.4781 17.9424 14.7362 17.3954 14.1892C16.8484 13.6423 16.1066 13.335 15.333 13.335C14.5595 13.335 13.8176 13.6423 13.2706 14.1892C12.7236 14.7362 12.4163 15.4781 12.4163 16.2516C12.4163 17.0252 12.7236 17.767 13.2706 18.314C13.8176 18.861 14.5595 19.1683 15.333 19.1683ZM11.1663 14.585C11.1663 14.6955 11.1224 14.8014 11.0443 14.8796C10.9662 14.9577 10.8602 15.0016 10.7497 15.0016C10.6392 15.0016 10.5332 14.9577 10.455 14.8796C10.3769 14.8014 10.333 14.6955 10.333 14.585C10.333 14.4745 10.3769 14.3685 10.455 14.2903C10.5332 14.2122 10.6392 14.1683 10.7497 14.1683C10.8602 14.1683 10.9662 14.2122 11.0443 14.2903C11.1224 14.3685 11.1663 14.4745 11.1663 14.585Z" fill="#383F51"/>
      </g>
      <defs>
      <clipPath id="clip0">
      <rect width="13.3333" height="13.3333" fill="white" transform="translate(8.6665 9.16797)"/>
      </clipPath>
      </defs>
    </svg>
<!-- 
      <img
        src="@/assets/images/onboarding/upload-img-icon.png"
        class="img-fluid img-upload-icon"
        alt="image upload icon"
      /> -->
    </div>
    <!-- <div class="text-center">
      <small
        class="text-secondary-orange font-semibold cursor-pointer"
        @click="$refs.fileInput.click()"
        >Click to upload picture here</small
      >
      <small
        class="text-primary-blue font-semibold d-block cursor-pointer"
        @click="removeImage"
        >Remove Picture</small
      >
      <small>Please select an image smaller than 1MB.</small>
    </div> -->
    <div v-if="isUploadingImage" class="d-flex justify-content-center py-2">
      <saving-loader :icon-color="'#0253B3'" />
    </div>
    <input
      ref="fileInput"
      type="file"
      @input="pickFile"
      accept="image/*"
      class="file-input"
    />
  </div>
</template>

<script>
import SavingLoader from "@/components/UI/ButtonSavingLoader";

export default {
  props: {
    imageUrl: {
      required: false,
      default: "",
    },
    isUploadingImage: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  components: {
    SavingLoader,
  },
  data() {
    return {
      previewImage: null,
    };
  },
  methods: {
    selectImage() {
      this.$refs.fileInput.click();
    },
    removeImage() {
      this.previewImage = null;
      this.$emit("remove-image");
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0].size > 1048576) {
        this.generateToast(
          "Selected image size is too large. Please upload an image smaller than 1MB!",
          "error"
        );
      } else {
        if (file && file[0]) {
          let reader = new FileReader();
          reader.onload = (e) => {
            this.previewImage = e.target.result;
          };
          reader.readAsDataURL(file[0]);
          this.$emit("input", file[0]);
        }
      }
    },
  },
  mounted(){
    console.log(this.imageUrl, "image ri")
  }
};
</script>

<style scoped lang="scss">
.imagePreviewWrapper {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: block;
  cursor: pointer;
  background-image: url("../../../assets/images/settings/blank-profile-picture.png");
  // margin: 0 auto;
  background-size: cover;
  background-position: center center;
}
.img-upload-icon {
  position: absolute;
  right: 0;
  top: 5rem;
}
.file-input {
  display: none;
}
</style>
